"use strict";
var $ = require("../internals/export");
var getBuiltIn = require("../internals/get-built-in");
var uncurryThis = require("../internals/function-uncurry-this");
var aCallable = require("../internals/a-callable");
var requireObjectCoercible = require("../internals/require-object-coercible");
var toPropertyKey = require("../internals/to-property-key");
var iterate = require("../internals/iterate");
var fails = require("../internals/fails");
var nativeGroupBy = Object.groupBy;
var create = getBuiltIn("Object", "create");
var push = uncurryThis([].push);
var DOES_NOT_WORK_WITH_PRIMITIVES = !nativeGroupBy || fails(function() {
  return nativeGroupBy("ab", function(it) {
    return it;
  }).a.length !== 1;
});
$({ target: "Object", stat: true, forced: DOES_NOT_WORK_WITH_PRIMITIVES }, {
  groupBy: function groupBy(items, callbackfn) {
    requireObjectCoercible(items);
    aCallable(callbackfn);
    var obj = create(null);
    var k = 0;
    iterate(items, function(value) {
      var key = toPropertyKey(callbackfn(value, k++));
      if (key in obj) push(obj[key], value);
      else obj[key] = [value];
    });
    return obj;
  }
});
